import { PUT } from '@/api/http';
import { END_POINTS } from '@/constants/endPoints';
import type { AdminProfile } from '@/stores/authStore';

export interface ISetMobilePinRequest {
  current_password: string;
  pin: string;
  pin_confirmation: string;
}

export const setMobilePinService = (payload: ISetMobilePinRequest) =>
  PUT<ISetMobilePinRequest, { message: string; admin: AdminProfile }>(
    END_POINTS.myMobilePin,
    payload,
  );
